import React, { useState } from 'react';
import axios from '../../api/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const POST_URL = '/api/v3/upload';

const VideoUplods = () => {
  // current user details
  const user = window.localStorage.getItem('token');
  const currentUser = JSON.parse(user).data._id;
  const currentUsername = JSON.parse(user).data.firstName;

  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [producer, setProducer] = useState('');
  const [makeup, setMakeup] = useState('');
  const [sound, setSound] = useState('');
  const [actors, setActors] = useState('');
  const [synopsis, setSynopsis] = useState('');
  const [budget, setBudget] = useState('');
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [videoTrailer, setVideoTrailer] = useState(null);
  const [percentageAgreement, setPercentageAgreement] = useState('');
  const [lock, setLock] = useState('');
  const [creatorId, setCreatorId] = useState(currentUser);
  const [username, setUsername] = useState(currentUsername);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [step1Valid, setStep1Valid] = useState(false);
  const [step2Valid, setStep2Valid] = useState(false);

  const handlePhotoChange = (e) => {
    setCoverPhoto(e.target.files[0]);
  };

  const handleVideoTrailerChange = (e) => {
    setVideoTrailer(e.target.files[0]);
  };

  

  const validateStep1 = () => {
    // Your validation logic for step 1
    const isValid = name !== '' && type !== '';
    setStep1Valid(isValid);
    return isValid;
  };

  const validateStep2 = () => {
    // Your validation logic for step 2
    const isValid = producer !== '' && makeup !== '' && sound !== '' && actors !== '' && synopsis !== '' && budget !== '';
    setStep2Valid(isValid);
    return isValid;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('type', type);
      formData.append('producer', producer);
      formData.append('makeup', makeup);
      formData.append('sound', sound);
      formData.append('actors', actors);
      formData.append('synopsis', synopsis);
      formData.append('budget', budget);
      formData.append('coverphoto', coverPhoto);
      formData.append('videotrailer', videoTrailer);
      formData.append('percentageAgreement', percentageAgreement);
      formData.append('lock', lock);
      formData.append('username', username);
      formData.append('creatorId', creatorId);

      await axios.post(POST_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      toast.success('Video upload success');
      setTimeout(() => {
        navigate('/admin/my-uploads');
        toast.info('Your content as been submitted successfully and awaiting approval, estimated response is 24 hours hour after upload.', { autoClose: 5000 });
      }, 2000);
    } catch (error) {
      console.error(error);
      console.error(error?.response);
      toast.error('Video upload failed');
    } finally {
      setLoading(false);
    }
  };

  // getting current date
  const current = new Date();
  const date = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  // formsteps
  const [step, setStep] = useState(1);
  const handleNext = () => {
    switch (step) {
      case 1:
        if (validateStep1()) {
          setStep(step + 1);
          step1Valid(true)
        }
        break;
      case 2:
        if (validateStep2()) {
          setStep(step + 1);
          step2Valid(true)
        }
        break;
      // Add more cases for additional steps if needed
      default:
        break;
    }
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  return (
    <div>
      <div className='mx-auto p-4 lg:container'>
        <div className='text-3xl font-bold text-center py-2'>
          <h1>
            Step {step} of 3
          </h1>
        </div>
        <div>
          <div className='bg-white p-4 lg:p-12'>
            <form onSubmit={handleSubmit} encType='multipart/form-data'>
              {(() => {
                switch (step) {
                  case 1:
                    return (
                      <div>
                        <h3>1.Movie Details</h3>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Name of movie <br />
                            <input
                              type='text'
                              className='px-3 py-1 w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Type of movie <br />
                            <select
                              className='px-3 py-1 w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              name='type'
                              id='type'
                              required
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            >
                              <option value=''>Choose option..</option>
                              <option value='Action'>Action</option>
                              <option value='Drama'>Drama</option>
                              <option value='Thriller'>Thriller</option>
                              <option value='Comedy'>Comedy</option>
                              <option value='Sci-Fi'>Sci-Fi</option>
                              <option value='Fiction'>Fiction</option>
                              <option value='Animation'>Animation</option>
                            </select>
                          </label>
                        </div>
                      </div>
                    );
                  case 2:
                    return (
                      <div>
                        <h3>2.Synopsis</h3>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Name of producers <br />
                            <input
                              type='text'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={producer}
                              onChange={(e) => setProducer(e.target.value)}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Makeup Artist <br />
                            <input
                              type='text'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={makeup}
                              onChange={(e) => setMakeup(e.target.value)}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Sound producers <br />
                            <input
                              type='text'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={sound}
                              onChange={(e) => setSound(e.target.value)}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Name of actors <br />
                            <input
                              type='text'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={actors}
                              onChange={(e) => setActors(e.target.value)}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Summary of film <span className='text-green-600'>({synopsis.length}/400 Characters)</span> <br />
                            <textarea
                              name='about'
                              id='about'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              cols='30'
                              rows='5'
                              value={synopsis}
                              onChange={(e) => setSynopsis(e.target.value)}
                              max={400}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Film Budget(Amount) <br />
                            <input
                              type='number'
                              className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                              required
                              value={budget}
                              onChange={(e) => setBudget(e.target.value)}
                            />
                          </label>
                        </div>
                      </div>
                    );
                  case 3:
                    return (
                      <div>
                        <h3>Upload files here</h3>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Cover Photo: <br />
                            <input
                              type='file'
                              required
                              name='coverphoto'
                              accept='image/*'
                              onChange={handlePhotoChange}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <label htmlFor='type'>
                            Upload Trailer file: <br />
                            <input
                              type='file'
                              required
                              name='videotrailer'
                              accept='video/*'
                              onChange={handleVideoTrailerChange}
                            />
                          </label>
                        </div>
                        <div className='p-2'>
                          <h3>3.Terms & Condition</h3>
                          <div className='p-2'>
                            <p>Revenue percentage agreement:</p>
                            <label htmlFor='video1'>
                              <input
                                type='radio'
                                id='video1'
                                name='video'
                                value='20/80'
                                checked={percentageAgreement === '20/80'}
                                onChange={(e) =>
                                  setPercentageAgreement(e.target.value)}
                              />
                            &nbsp;20/80
                            </label>
                            <br />
                            <label htmlFor='video2'>
                              <input
                                type='radio'
                                id='video2'
                                name='video'
                                value='30/70'
                                checked={percentageAgreement === '30/70'}
                                onChange={(e) =>
                                  setPercentageAgreement(e.target.value)}
                              />
                            &nbsp;30/70
                            </label>
                            <br />
                            <label htmlFor='video3'>
                              <input
                                type='radio'
                                id='video'
                                name='video'
                                value='40/60'
                                checked={percentageAgreement === '40/60'}
                                onChange={(e) =>
                                  setPercentageAgreement(e.target.value)}
                              />
                            &nbsp;40/60
                            </label>
                          </div>
                          <div className='p-2'>
                            <label htmlFor='amount'>
                              Lock video amount
                              <select
                                name='amount'
                                id='amount'
                                className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                                required
                                value={lock}
                                onChange={(e) => setLock(e.target.value)}
                              >
                                <option value=''>Amount..</option>
                                <option value='50'>50</option>
                                <option value='150'>100</option>
                                <option value='200'>200</option>
                              </select>
                            </label>
                          </div>
                          <section>
                            <div className='p-2 hidden'>
                              <label htmlFor='type'>
                                Uploaded by: <br />
                                <input
                                  type='text'
                                  className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                                  value={creatorId}
                                  onChange={(e) =>
                                    setCreatorId({
                                      ...creatorId,
                                      _id: e.target.value
                                    })}
                                  disabled
                                />
                              </label>
                            </div>
                            <div className='p-2'>
                              <label htmlFor='type'>
                                Uploaded by: <br />
                                <input
                                  type='text'
                                  className='px-3 py-1  w-full bg-slate-100 border  border-slate-300 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block focus:ring-1'
                                  value={username}
                                  onChange={(e) =>
                                    setUsername({
                                      ...username,
                                      username: e.target.value
                                    })}
                                  disabled
                                />
                              </label>
                            </div>

                            <div className='space-y-3 p-4'>
                              <h5>
                                <b>Upload Date</b> <p>{date}</p>
                              </h5>
                            </div>
                          </section>
                          <div className='mt-1'>
                            <input type='checkbox' required /> &nbsp;
                            <label htmlFor='agree'>
                              I have read and agreed to this{' '}
                              <a className='hover:text-blue-500' href='#/'>
                                <u>terms&conditions</u>
                              </a>
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })()}
              <div className='flex justify-between mt-6'>
                {step > 1 && (
                  <button
                    className='bg-gray-300 px-6 py-1.5 rounded-lg stext-gray-700 hover:bg-gray-400'
                    onClick={handleBack}
                  >
                    Back
                  </button>
                )}
                {step < 3 && (
                  <button
                    className='bg-blue-500 px-6 py-1.5 rounded-lg text-white hover:bg-blue-600'
                    onClick={handleNext}
                  >
                    Next
                  </button>
                )}
                {step === 3 && (
                  <button
                    type='submit'
                    disabled={loading}
                    className={`bg-blue-700 text-white px-6 py-1 rounded-sm ${
                      loading ? 'bg-blue-500' : 'hover:bg-blue-600'
                    }`}
                  >
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoUplods;
